import * as React from 'preact/compat'
import cn from 'classnames'
import Consent from '../Consent'
import BackButton from '../BackButton'
import Api from '../../../api'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'
import buttonsCss from '../../../../css/buttons.pcss.json'
import formCss from '../../../../css/form.pcss.json'
import { captureFetchException, loadStylesheet } from '../../../common/helpers'
import PasswordInput from '../../PasswordInput'

interface StateTypes {
  isSending: boolean,
  error: string | null,
  error_fields: string[]
}

export default class PageLoginSG extends React.Component<DialogComponentPropTypes, StateTypes> {

  state: StateTypes = {
    isSending: false,
    error: null,
    error_fields: []
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  goBack = () => this.props.switchPage('index')
  goToPasswordRestoration = () => this.props.switchPage('restore-password')

  login = async (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()

    this.setState({
      isSending: true,
      error: null,
      error_fields: []
    })

    const formData = new FormData(event.currentTarget)

    const captcha = formData.get('g-recaptcha-response')

    if (!captcha) {
      this.setState({
        error: 'Пожалуйста, пройди капчу',
        isSending: false
      })
      return
    }

    Api.post({
      url: 'auth/login',
      body: formData,
      init: {
        credentials: 'include'
      }
    })
      .then(result => {
        if (result.success) {
          window.location.reload()
          return
        } else if (result.mfa) {
          this.props.switchPage('mfa-verify')
          return
        } else {
          this.setState({
            isSending: false,
            error: result.error,
            error_fields: result.error_fields ?? []
          }, () => {
            // @ts-ignore Мне лень описывать типы для grecaptcha
            grecaptcha.reset()
          })
        }
      })
      .catch((e) => {
        captureFetchException(e)
        this.setState({
          isSending: false,
          error: 'Произошла непредвиденная ошибка. Повтори позже.',
          error_fields: []
        }, () => {
          // @ts-ignore Мне лень описывать типы для grecaptcha
          grecaptcha.reset()
        })
      })
  }

  render() {
    const { isSending, error } = this.state

    return <>
      <BackButton goBack={this.goBack}/>
      <div className={styles['auth-header']}>
        <h1>Войти</h1>
      </div>
      <form onSubmit={this.login} style='display: flex; flex-direction: column; align-items: center;'>
        <input
          type='text'
          placeholder='Почта/логин'
          name='login'
          autoComplete='email'
          minLength={3}
          required
          className={cn(formCss['input'], {
            [formCss['input--error']]: this.state.error_fields?.includes('login')
          })}
          autocomplete="username"
          style='margin-bottom: 37px;'
        />
        <PasswordInput
          placeholder='Пароль'
          name='password'
          autocomplete='current-password'
          minLength={3}
          hasError={this.state.error_fields?.includes('password')}
          required
          style='margin-bottom: 37px;'
        />
        <div
          className="g-recaptcha"
          data-plugins='recaptcha'
          data-sitekey={window.recaptchaSiteKey}
        />
        <p
          className={formCss['error-hint']}
          style={{ opacity: error ? 1 : 0, width: '100%', textAlign: 'center' }}
        >{error || 'Нет ошибок'}</p>
        <button
          type="submit"
          disabled={isSending}
          className={buttonsCss['primary']}
          style='min-width: 170px'
        >Войти
        </button>
        <button
          onClick={this.goToPasswordRestoration}
          type="button"
          className={styles['auth-forgot-password-button']}
        >
          Я не помню пароль
        </button>
      </form>
      <Consent/>
    </>
  }
}
